export default __webpack_public_path__ + "images/3c81d6a81380746a4635ee046f706d4e-valentines_collections_touchpoint_image.webp";